import React from 'react';
import FinancialGroupedBarChart from '@components/charts/FinancialGroupedBarChart';
import TrendsSection from './TrendsSection';
import ChartLegend from './ChartLegend';
import FinancialMatrixTable from './FinancialMatrixTable';
import type { FinancialSection } from '@app-types/performanceTrends';

export interface ResearchDevelopmentSectionProps {
  data: FinancialSection;
}

/** Research/development/capex section: 3-series grouped bars (Figma 3490:22286). */
const ResearchDevelopmentSection: React.FC<ResearchDevelopmentSectionProps> = ({ data }) => (
  <TrendsSection
    title={data.title}
    headerNodeId={data.headerNodeId}
    sectionNodeId={data.sectionNodeId}
    anchorId="research-development"
  >
    <div className="trends-financial-chart">
      <FinancialGroupedBarChart
        data={data.chart}
        height={202}
        ariaLabel={`${data.title}のチャート`}
      />
      <ChartLegend series={data.legend} nodeId="3226:15592" />
    </div>
    <FinancialMatrixTable data={data.table} caption={data.title} />
  </TrendsSection>
);

export default ResearchDevelopmentSection;
